export const JOB_STATUS = {
  PENDING: 'Pending',
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  ON_HOLD: 'On Hold',
  READY: 'Ready',
  RETURN: 'Return',
  COMPLETED: 'Completed',
};

export const ONGOING_FILTER_STATUSES = [
  'all',
  JOB_STATUS.PENDING,
  JOB_STATUS.ASSIGNED,
  JOB_STATUS.IN_PROGRESS,
  JOB_STATUS.ON_HOLD,
  JOB_STATUS.READY,
];

export const ADMIN_SETTABLE_STATUSES = [
  JOB_STATUS.PENDING,
  JOB_STATUS.ASSIGNED,
  JOB_STATUS.IN_PROGRESS,
  JOB_STATUS.ON_HOLD,
  JOB_STATUS.READY,
  JOB_STATUS.RETURN,
];

export function isCompletedStatus(status) {
  return (status || '').toString().toLowerCase().includes('completed');
}

export function isReturnStatus(status) {
  return (status || '').toString().toLowerCase().includes('return');
}

export function isReadyOrReturnStatus(status) {
  const s = (status || '').toString().toLowerCase();
  return s.includes('ready') || s.includes('return');
}

export function getStatusChipStyle(status, isDarkMode = false) {
  const s = (status || '').toString().toLowerCase();
  const styles = {
    ready: { backgroundColor: isDarkMode ? '#166534' : '#bbf7d0', color: isDarkMode ? '#bbf7d0' : '#065f46' },
    completed: { backgroundColor: isDarkMode ? '#166534' : '#bbf7d0', color: isDarkMode ? '#bbf7d0' : '#065f46' },
    return: { backgroundColor: isDarkMode ? '#312e81' : '#e0e7ff', color: isDarkMode ? '#c7d2fe' : '#3730a3' },
    'in progress': { backgroundColor: isDarkMode ? '#134e4a' : '#99f6e4', color: isDarkMode ? '#99f6e4' : '#0f766e' },
    inprogress: { backgroundColor: isDarkMode ? '#134e4a' : '#99f6e4', color: isDarkMode ? '#99f6e4' : '#0f766e' },
    pending: { backgroundColor: isDarkMode ? '#92400e' : '#ffedd5', color: isDarkMode ? '#fcd34d' : '#92400e' },
    assigned: { backgroundColor: isDarkMode ? '#5b21b6' : '#e9d5ff', color: isDarkMode ? '#d8b4fe' : '#5b21b6' },
    'on hold': { backgroundColor: isDarkMode ? '#7f1d1d' : '#fecaca', color: isDarkMode ? '#fca5a5' : '#7f1d1d' },
    hold: { backgroundColor: isDarkMode ? '#7f1d1d' : '#fecaca', color: isDarkMode ? '#fca5a5' : '#7f1d1d' },
    default: { backgroundColor: isDarkMode ? '#5b21b6' : '#e9d5ff', color: isDarkMode ? '#d8b4fe' : '#5b21b6' },
  };
  const key = Object.keys(styles).find((k) => s.includes(k)) || 'default';
  return styles[key];
}
